import { Entity } from "src/app/helpers/entity";

export class Savingstransaction  implements Entity {

    Id : number;
    TransactionNo : number;
    SavingsId : number;
    TransactionDate : Date;
    CollectionAmount : number;
    PrincipleAmount : number;
    InterestAmount :  number;
    BalanceAmount : number;
    LateFeeAmount : number;
    InstallmentNo : number;
    IsPartPayment : boolean;
    IsPreclosure : boolean;
    PaymentTypeId : number;
    PaymentBankId : number;
    ChequeNo : string;
    Remarks :  string;
    IsAccruedAmount : boolean;
    IsSavingsclosed : boolean; 
    IsReceiptAmount : boolean; 
    ReportName :string;

    EmployeeId:  number;
    EmployeeBranchId:  number;
    CompanyId:  number;
    SaasId:  number;
    CreatedDate:  Date;
    ModifiedDate:  Date;
    IsActive:  boolean;
    Flag :number;
    IsOpening: boolean;

}
